import { Chip } from "@mui/material";
import { STATUS } from "configs/constant";
import { NoRecordField } from "../NoRecordField";

export const BadgeStatusCustomer = (status) => {
  if (!status) {
    return NoRecordField(status);
  }
  let color = "";
  switch (status.toLowerCase()) {
    case STATUS.REGISTERED.toLowerCase():
      color += "primary";
      break;
    case STATUS.DONE_TAKING_SCHEDULE.toLowerCase():
      color += "info";
      break;
    case STATUS.NOTIFICATION_H1.toLowerCase():
      color += "warning";
      break;
    case STATUS.DONE_CLEANING.toLowerCase():
      color += "success";
      break;
    case STATUS.ALL_DONE.toLowerCase():
      color += "success";
      break;
    default:
      color += "error";
      break;
  }
  return <Chip size="small" label={status} variant="filled" color={color} />;
};

export const BadgeExistData = (item) => {
  if (!item) {
    return NoRecordField(item);
  } else {
    let color = "info";
    return <Chip size="small" label={item} variant="filled" color={color} />;
  }
};
